// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__320Lt","header":"ReportDetails_header__191Fl","title":"ReportDetails_title__2130E","left":"ReportDetails_left__194My"};